// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomSysOrganizationsLocationsSelect from './data'

export default function DataVaxiomSysOrganizationsLocationsSelectFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomSysOrganizationsLocationsSelect">
      <DataVaxiomSysOrganizationsLocationsSelect {...props}>
        {children}
      </DataVaxiomSysOrganizationsLocationsSelect>
    </Flow>
  )
}
